/**
 * Youro Discovery — Such-Modul (Meilisearch).
 *
 * Ein Skript fuer zwei Einsatzzwecke:
 *  1. Autocomplete-Kapsel (Vorschau waehrend des Tippens, wenige Treffer)
 *  2. Volle Ergebnisliste (nach Enter/Lupe-Klick, viele Treffer)
 *
 * Sicherheit: Der Search-Only-Key unten ist ABSICHTLICH oeffentlich sichtbar
 * (kann nur lesen/suchen, kein Schreibzugriff moeglich) - das ist normal fuer
 * Meilisearch/Algolia-artige Client-seitige Suchen, kein Geheimnis.
 *
 * Einbau: siehe README.md im selben Ordner.
 */
(function (global) {
  'use strict';

  var MEILI_HOST = 'https://search.youro.shop';
  var SEARCH_KEY = 'e3971b2e049ccd27dbf1a973f2c3172d728aecb221a9261384404d506dd7b57d'; // wird beim Einbau ersetzt, siehe README.md

  // ── Kernsuche ──────────────────────────────────────────────

  function search(query, limit, facets, filter) {
    var body = { q: query, limit: limit || 6 };
    if (facets && facets.length) { body.facets = facets; }
    if (filter) { body.filter = filter; }
    return fetch(MEILI_HOST + '/indexes/products/search', {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + SEARCH_KEY,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) { throw new Error('Suche fehlgeschlagen (HTTP ' + r.status + ')'); }
      return r.json();
    });
  }

  // Erweiterte Suche fuer die Ergebnisseiten-Filter-Sidebar (Lagerbestand,
  // Preis, Sortierung) - eigene Funktion statt search() zu veraendern, damit
  // die Autocomplete-Kapsel unberuehrt bleibt (Michelle 15.07.).
  //
  // opts.hybrid + opts.timeoutMs: KI-Bedeutungssuche (Phase 3b, anderer Chat
  // 17.07.) - versteht auch sinngemaesse Anfragen ("moebel ausbessern" findet
  // einen Wachsreparatur-Stick). Faellt bei Zeitueberschreitung/Fehler
  // automatisch UND TRANSPARENT auf die normale Suche zurueck (derselbe
  // Aufruf, kein zusaetzlicher Code im Aufrufer noetig) - Kund:innen sehen
  // nie einen Fehler. Nur fuer die volle Ergebnisseite gedacht, NICHT fuer
  // die Autocomplete-Kapsel (die bleibt bewusst unveraendert, siehe Chat-
  // Verlauf mit dem anderen Chat).
  function searchAdvanced(query, opts) {
    opts = opts || {};

    function runOnce(withHybrid) {
      // page/hitsPerPage statt limit/offset (anderer Chat, 18.07.): Meilisearch
      // wendet rankingScoreThreshold auf Trefferzahl/Facetten NUR in diesem
      // Modus an - mit limit/offset blieb z.B. "Jacken Damen (8)" stehen,
      // obwohl beim echten Filtern nur 2 Treffer uebrig blieben. Bekanntes,
      // nicht offensichtlich dokumentiertes Meilisearch-Verhalten.
      var hitsPerPage = opts.limit != null ? opts.limit : 24;
      var page = opts.offset ? Math.floor(opts.offset / (hitsPerPage || 1)) + 1 : 1;
      var body = { q: query, page: page, hitsPerPage: hitsPerPage };
      if (opts.facets && opts.facets.length) { body.facets = opts.facets; }
      if (opts.filter) { body.filter = opts.filter; }
      if (opts.sort && opts.sort.length) { body.sort = opts.sort; }

      var fetchOptions = {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + SEARCH_KEY,
          'Content-Type': 'application/json'
        },
        body: null
      };

      if (withHybrid && opts.hybrid) {
        body.hybrid = opts.hybrid;
        // rankingScoreThreshold (anderer Chat, 18.07.): loest sowohl die zu
        // breite Relevanz (Trauerkarte fast gleichauf mit Holzreparatur-
        // Produkten) als auch die unrealistische estimatedTotalHits-Schaetzung
        // an der Wurzel - live an 4 Testabfragen kalibriert (0.8), kein
        // semanticRatio-Downscaling (das haette nur alles gleichmaessig
        // abgeschwaecht statt Relevantes von Irrelevantem zu trennen).
        if (opts.rankingScoreThreshold != null) { body.rankingScoreThreshold = opts.rankingScoreThreshold; }
        if (opts.timeoutMs) {
          var controller = new AbortController();
          fetchOptions.signal = controller.signal;
          setTimeout(function () { controller.abort(); }, opts.timeoutMs);
        }
      }
      fetchOptions.body = JSON.stringify(body);

      return fetch(MEILI_HOST + '/indexes/products/search', fetchOptions).then(function (r) {
        if (!r.ok) { throw new Error('Suche fehlgeschlagen (HTTP ' + r.status + ')'); }
        return r.json();
      }).then(function (data) {
        data._usedHybrid = withHybrid && !!opts.hybrid;
        // page/hitsPerPage-Antworten haben "totalHits" statt
        // "estimatedTotalHits" - hier spiegeln, damit bestehender
        // Aufrufer-Code (Trefferzahl-Anzeige) unveraendert bleibt.
        if (data.totalHits != null) { data.estimatedTotalHits = data.totalHits; }
        return data;
      });
    }

    if (!opts.hybrid) { return runOnce(false); }

    return runOnce(true).catch(function () {
      return runOnce(false); // Bedeutungssuche zu langsam/fehlgeschlagen -> stille Ausfallsicherung
    });
  }

  // Aehnliche Produkte (Phase 5a, 18.07.) - nutzt Meilisearchs eingebautes
  // /similar auf den schon gespeicherten Gemini-Embeddings, kein KI-Aufruf
  // zur Laufzeit noetig, daher auch kein Timeout-Fallback wie bei der
  // Bedeutungssuche. Liefert nur die RELEVANZ-REIHENFOLGE (Handles) - die
  // echten Produktdaten (Preis, Varianten fuer "In den Warenkorb") holt sich
  // die aufrufende Seite selbst frisch von Shopify, siehe
  // snippets/youro-pb-20-recommendations.liquid.
  function getSimilarProducts(productId, limit) {
    return fetch(MEILI_HOST + '/indexes/products/similar', {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + SEARCH_KEY,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ id: productId, embedder: 'gemini', limit: limit || 6 })
    }).then(function (r) {
      if (!r.ok) { throw new Error('Aehnliche-Produkte-Abfrage fehlgeschlagen (HTTP ' + r.status + ')'); }
      return r.json();
    });
  }

  // ── Patroa-Studio-Sichtbarkeit einschraenken (Entscheidung 014, anderer
  // Chat 16.07., Michelle 21.07.: "kleine Verbesserung einbauen") ──
  // Patroa Studio ist mit ~44% des Katalogs (fast nur Poster/Wanddeko) die mit
  // Abstand groesste Marke - taucht sonst bei praktisch jeder Anfrage in Massen
  // auf und verdraengt alle anderen Marken. Zentral hier gepflegt (nicht in
  // youro-search-native.js dupliziert), weil beide Integrationsschritte
  // (Kapsel hier + volle Ergebnisseite dort) dieselbe Liste brauchen.

  var RESTRICTED_VENDOR = 'Patroa Studio';
  var RESTRICTED_VENDOR_PRODUCT_TYPES = [
    'Poster',
    'Wohnen/Dekoration',
    'Wohnen/Dekoration/Wanddekoration/Wandbilder & Poster'
  ];
  // Startliste (bewusst grosszuegig, deckt gaengige Alltagsformulierungen wie
  // "bild fuer die wand"/"deko wohnzimmer" mit ab) - sobald genug echte
  // Suchbegriffe geloggt sind, anhand der Logs nachschaerfen statt weiter zu
  // raten (siehe Entscheidung 014). Bewusst getrennt von
  // config/synonyms.json (serverseitige Meilisearch-Synonymgruppe) - hier
  // geht es um eine clientseitige Ja/Nein-Entscheidung "gehoert diese
  // Anfrage zum Poster-Thema".
  var RESTRICTED_VENDOR_TRIGGER_WORDS = [
    'poster', 'plakat', 'plakate',
    'bild', 'bilder', 'wandbild', 'wandbilder', 'wandkunst', 'wandschmuck', 'wandposter',
    'deko', 'dekoration', 'wanddeko', 'wanddekoration',
    'rahmen', 'bilderrahmen',
    'kunstdruck', 'kunstdrucke', 'kunstposter', 'artprint', 'art print', 'wall art', 'print',
    'leinwand', 'leinwandbild', 'leinwanddruck',
    'patroa'
  ];
  // Wortstaemme, die haeufig Teil laengerer deutscher Komposita ohne
  // Leerzeichen sind (z.B. "kunstliebhaber", "kunsthandwerk") - live
  // gefunden: "geschenk fuer kunstliebhaber" wurde faelschlich komplett
  // ausgeblendet, weil "kunst" darin keine eigene Wortgrenze hat (anderer
  // Chat, Nachtrag 21.07.). Bewusst als Teilstring statt Wortgrenze geprueft.
  // Restrisiko (z.B. "Kunststoffregal" wuerde die Marke faelschlich zulassen)
  // ist gering, weil Meilisearchs rankingScoreThreshold thematisch
  // unpassende Treffer ohnehin abschneidet.
  var RESTRICTED_VENDOR_TRIGGER_SUBSTRINGS = ['kunst'];

  function escapeFilterValue(value) {
    return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function queryMentionsRestrictedVendorTopic(query) {
    var normalized = String(query || '').toLowerCase();
    var matchesWordList = RESTRICTED_VENDOR_TRIGGER_WORDS.some(function (word) {
      return word.indexOf(' ') !== -1
        ? normalized.indexOf(word) !== -1
        : new RegExp('\\b' + word + '\\b').test(normalized);
    });
    if (matchesWordList) { return true; }
    return RESTRICTED_VENDOR_TRIGGER_SUBSTRINGS.some(function (stem) {
      return normalized.indexOf(stem) !== -1;
    });
  }

  // activeVendors: Array der aktuell im Marken-Filter ausgewaehlten Werte
  // (oder null/leer, wenn kein Marken-Filter aktiv ist - z.B. in der
  // Autocomplete-Kapsel, die keine Facetten-Filter kennt).
  function buildRestrictedVendorClause(query, activeVendors) {
    // Keine Sperre, wenn: Suchbegriff passt zum Thema, ODER die Marke bereits
    // explizit ueber den Marken-Filter ausgewaehlt ist (sonst wuerde ein
    // aktiver Patroa-Studio-Filter zu einem widerspruechlichen 0-Treffer-
    // Filter fuehren).
    if (queryMentionsRestrictedVendorTopic(query)) { return null; }
    if (activeVendors && activeVendors.indexOf(RESTRICTED_VENDOR) !== -1) { return null; }
    var types = RESTRICTED_VENDOR_PRODUCT_TYPES.map(function (t) {
      return '"' + escapeFilterValue(t) + '"';
    }).join(',');
    return 'NOT (vendor_name = "' + escapeFilterValue(RESTRICTED_VENDOR) + '" AND product_type IN [' + types + '])';
  }

  // ── Kategorie-Pfade lesbar machen, z.B. "Damenmode/Bekleidung/Hosen" → "Hosen Damen"
  // (Meilisearch liefert echte Kategorie-Pfade als product_type-Facette, kein separater
  // Vorschlags-Datensatz vorhanden - wir bauen Pillen/Kategorien direkt aus diesen echten
  // Treffer-Facetten, Michelle 15.07.: "gerne recherchieren, was Best Practices sind"). ──

  var TOP_LEVEL_LABELS = {
    'Damenmode': 'Damen',
    'Herrenmode': 'Herren',
    'Kindermode': 'Kinder'
  };

  function humanizeProductType(path) {
    if (!path) { return ''; }
    if (path.indexOf('/') === -1) {
      return path.replace(/[-_]+/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    }
    var parts = path.split('/');
    var leaf = parts[parts.length - 1];
    var qualifier = TOP_LEVEL_LABELS[parts[0]];
    if (qualifier && qualifier !== leaf) { return leaf + ' ' + qualifier; }
    return leaf;
  }

  function topFacetEntries(facetDistribution, field, max) {
    if (!facetDistribution || !facetDistribution[field]) { return []; }
    var dist = facetDistribution[field];
    return Object.keys(dist)
      .map(function (value) { return { value: value, count: dist[value] }; })
      .sort(function (a, b) { return b.count - a.count; })
      .slice(0, max);
  }

  // ── Preis-Text: "ab X,XX €" bei Preisspanne statt kryptischem "X,XX €+"
  // (Michelle 15.07., Vergleich mit der alten Shopify-Suche). ──

  function formatPriceText(hit) {
    if (hit.price_min == null) { return ''; }
    var priceText = Number(hit.price_min).toFixed(2).replace('.', ',') + ' €';
    var isRange = hit.price_max != null && hit.price_max !== hit.price_min;
    return isRange ? ('ab ' + priceText) : priceText;
  }

  // ── XSS-sicheres Rendering (nur textContent, nie innerHTML mit Produktdaten) ──

  function buildResultItem(hit) {
    var item = document.createElement('a');
    item.className = 'youro-search-item';
    item.href = '/products/' + (hit.handle || ''); // Handle muss ggf. ergaenzt werden, siehe README

    var img = document.createElement('img');
    img.className = 'youro-search-item__image';
    img.src = hit.image || '';
    img.alt = '';
    item.appendChild(img);

    var textWrap = document.createElement('div');
    textWrap.className = 'youro-search-item__text';

    var title = document.createElement('div');
    title.className = 'youro-search-item__title';
    title.textContent = hit.title || '';
    textWrap.appendChild(title);

    var brand = document.createElement('div');
    brand.className = 'youro-search-item__brand';
    brand.textContent = hit.vendor_name || '';
    textWrap.appendChild(brand);

    if (hit.available === false) {
      var unavailable = document.createElement('div');
      unavailable.className = 'youro-search-item__unavailable';
      unavailable.textContent = 'Ausverkauft';
      textWrap.appendChild(unavailable);
    }
    item.appendChild(textWrap);

    if (hit.price_min != null) {
      var price = document.createElement('div');
      price.className = 'youro-search-item__price';
      price.textContent = formatPriceText(hit);
      item.appendChild(price);
    }

    return item;
  }

  // Youro: groessere Bild-Karte fuer die Autocomplete-Kapsel, horizontal
  // scrollbar - Michelle fand nach Vergleich mit der alten Shopify-Suche
  // groessere Produktbilder ansprechender/besser wiedererkennbar als eine
  // schmale Liste mit winzigen Thumbnails (15.07., UX-Feedback nach
  // Vergleichs-Screenshot). Eigene Funktion statt buildResultItem() zu
  // veraendern, damit die volle Ergebnisseite (nutzt buildResultItem ueber
  // renderInto/renderResultsPage) unberuehrt bleibt.
  function buildResultCard(hit) {
    var item = document.createElement('a');
    item.className = 'youro-search-card';
    item.href = '/products/' + (hit.handle || '');

    var imgWrap = document.createElement('div');
    imgWrap.className = 'youro-search-card__image-wrap';
    var img = document.createElement('img');
    img.className = 'youro-search-card__image';
    img.src = hit.image || '';
    img.alt = '';
    imgWrap.appendChild(img);
    item.appendChild(imgWrap);

    var title = document.createElement('div');
    title.className = 'youro-search-card__title';
    title.textContent = hit.title || '';
    item.appendChild(title);

    if (hit.vendor_name) {
      var brand = document.createElement('div');
      brand.className = 'youro-search-card__brand';
      brand.textContent = hit.vendor_name;
      item.appendChild(brand);
    }

    if (hit.price_min != null) {
      var price = document.createElement('div');
      price.className = 'youro-search-card__price';
      price.textContent = formatPriceText(hit);
      item.appendChild(price);
    }

    if (hit.available === false) {
      var unavailable = document.createElement('div');
      unavailable.className = 'youro-search-card__unavailable';
      unavailable.textContent = 'Ausverkauft';
      item.appendChild(unavailable);
    }

    return item;
  }

  function renderInto(container, hits) {
    container.innerHTML = ''; // Container geleert, aber nur mit eigens gebauten Elementen befuellt (kein rohes HTML)
    if (!hits.length) {
      var empty = document.createElement('div');
      empty.className = 'youro-search-empty';
      empty.textContent = 'Keine Treffer gefunden.';
      container.appendChild(empty);
      return;
    }
    hits.forEach(function (hit) {
      container.appendChild(buildResultItem(hit));
    });
  }

  // Vervollstaendigungs-Pillen: echte WOERTER aus den Treffer-Titeln, die mit
  // der Eingabe beginnen (z.B. "mess" -> "Messer") - bewusst NICHT dieselbe
  // Quelle wie die Kategorien-Chips unten, sonst zeigen beide dasselbe
  // doppelt (Michelle 16.07., Vergleichsscreenshot: "es dopplt sich voll").
  // Kein separater Anfragen-Aufwand, weil wir nur die Titel der ohnehin schon
  // geladenen Treffer durchsuchen.
  function buildQueryCompletions(hits, query, max) {
    var q = query.trim().toLowerCase();
    if (!q) { return []; }
    var counts = {};
    hits.forEach(function (hit) {
      var title = hit.title || '';
      title.split(/[\s\-,\/()]+/).forEach(function (word) {
        var lower = word.toLowerCase();
        if (lower.length > q.length && lower.indexOf(q) === 0) {
          if (!counts[lower]) { counts[lower] = { word: word, count: 0 }; }
          counts[lower].count += 1;
        }
      });
    });
    return Object.keys(counts)
      .map(function (key) { return counts[key]; })
      .sort(function (a, b) { return b.count - a.count; })
      .slice(0, max);
  }

  function buildSuggestPill(completion, query, onSelect) {
    var pill = document.createElement('button');
    pill.type = 'button';
    pill.className = 'youro-search-suggest-pill';

    var label = document.createElement('span');
    var prefix = completion.word.slice(0, query.length);
    var rest = completion.word.slice(query.length);
    label.appendChild(document.createTextNode(prefix));
    var bold = document.createElement('b');
    bold.textContent = rest;
    label.appendChild(bold);
    pill.appendChild(label);

    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    var path = document.createElementNS(ns, 'path');
    path.setAttribute('d', 'M7 17L17 7M7 7h10v10');
    svg.appendChild(path);
    pill.appendChild(svg);

    pill.addEventListener('click', function () { onSelect(completion.word); });
    return pill;
  }

  // Passende Kategorien: Direkt-Link zur vollen Ergebnisseite, vorgefiltert
  // auf diese Kategorie (product_type-Parameter ist schon jetzt forward-
  // kompatibel zur kommenden Filter-Sidebar, greift erst sobald die dort
  // eingebaut ist - bis dahin ignoriert die Ergebnisseite den Parameter
  // einfach und zeigt die normale Suche).
  function buildCategoryChip(entry, query, resultsPageUrl) {
    var chip = document.createElement('a');
    chip.className = 'youro-search-category-chip';
    chip.href = resultsPageUrl + '?q=' + encodeURIComponent(query) + '&product_type=' + encodeURIComponent(entry.value);

    var label = document.createElement('span');
    label.textContent = humanizeProductType(entry.value);
    chip.appendChild(label);

    var count = document.createElement('span');
    count.className = 'youro-search-category-chip__count';
    count.textContent = ' (' + entry.count + ')';
    chip.appendChild(count);

    return chip;
  }

  function buildNavArrow(direction) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'youro-search-nav youro-search-nav--' + direction;
    btn.setAttribute('aria-label', direction === 'prev' ? 'Zurück' : 'Weiter');
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    var poly = document.createElementNS(ns, 'polyline');
    poly.setAttribute('points', direction === 'prev' ? '15 6 9 12 15 18' : '9 6 15 12 9 18');
    svg.appendChild(poly);
    btn.appendChild(svg);
    return btn;
  }

  // Ladezustand waehrend die Anfrage laeuft (bis zu ~1,5s bei der
  // Bedeutungssuche) - vorher sah die Kapsel/Ergebnisliste in der Zwischenzeit
  // aus wie "keine Treffer" (Michelle 20.07.). Eigenes Motiv statt generischem
  // Spinner: ein rotierender Ring aus den 12 EU-Sternen (wie auf der
  // Europaflagge) um einen Mittelpunkt - "wir durchsuchen Europa" (Michelle:
  // "Europa-Zeichen ... Spotlight ... wir durchsuchen Europa").
  function buildLoadingState() {
    // Ganz einfacher Spinner statt des EU-Sterne-Rings von vorhin (Michelle
    // 21.07.: "das Sternenband haben wir nirgendwo sonst ... ganz simples
    // Ladezeichen").
    var wrap = document.createElement('div');
    wrap.className = 'youro-search-loading';

    var spinner = document.createElement('div');
    spinner.className = 'youro-search-spinner';
    wrap.appendChild(spinner);

    return wrap;
  }

  // Youro: Autocomplete-Kapsel bekommt ein echtes Karussell (mehr Treffer als
  // sichtbar, per Pfeil durchscrollbar) PLUS einen "Alle Ergebnisse
  // anzeigen"-Fusszeilen-Link - fehlte bisher komplett (Michelle 15.07.,
  // zwei Feedback-Runden nach Vergleich mit der alten Shopify-Suche: erst
  // fehlte der Link, dann fehlten die Scroll-Pfeile). Eigene Funktion statt
  // renderInto(), damit die volle Ergebnisseite unberuehrt bleibt.
  function renderAutocomplete(container, data, query, resultsPageUrl, onSelectSuggestion) {
    container.innerHTML = '';
    var hits = data.hits || [];
    if (!hits.length) {
      var empty = document.createElement('div');
      empty.className = 'youro-search-empty';
      empty.textContent = 'Keine Treffer gefunden.';
      container.appendChild(empty);
      return;
    }

    var completions = buildQueryCompletions(hits, query, 4);
    if (completions.length) {
      var suggestRow = document.createElement('div');
      suggestRow.className = 'youro-search-suggest-row';
      completions.forEach(function (completion) {
        suggestRow.appendChild(buildSuggestPill(completion, query, onSelectSuggestion));
      });
      container.appendChild(suggestRow);
    }

    var rowWrap = document.createElement('div');
    rowWrap.className = 'youro-search-row-wrap';

    var row = document.createElement('div');
    row.className = 'youro-search-row';
    hits.forEach(function (hit) {
      row.appendChild(buildResultCard(hit));
    });
    rowWrap.appendChild(row);

    var prevBtn = buildNavArrow('prev');
    var nextBtn = buildNavArrow('next');
    rowWrap.appendChild(prevBtn);
    rowWrap.appendChild(nextBtn);
    container.appendChild(rowWrap);

    function updateArrows() {
      var maxScroll = row.scrollWidth - row.clientWidth;
      prevBtn.hidden = row.scrollLeft <= 4;
      nextBtn.hidden = row.scrollLeft >= maxScroll - 4;
    }
    // Erst nach dem naechsten Frame messen - scrollWidth ist sonst noch 0,
    // solange die Kapsel gerade erst eingeblendet wird.
    requestAnimationFrame(updateArrows);
    row.addEventListener('scroll', updateArrows);

    function scrollByCards(direction) {
      var cardWidth = row.firstElementChild ? row.firstElementChild.getBoundingClientRect().width + 12 : 150;
      row.scrollBy({ left: direction * cardWidth * 2, behavior: 'smooth' });
    }
    prevBtn.addEventListener('click', function () { scrollByCards(-1); });
    nextBtn.addEventListener('click', function () { scrollByCards(1); });

    var footer = document.createElement('a');
    footer.className = 'youro-search-viewall';
    footer.href = resultsPageUrl + '?q=' + encodeURIComponent(query);

    var footerLabel = document.createElement('span');
    var countSuffix = data.estimatedTotalHits ? (' (' + data.estimatedTotalHits + ')') : '';
    footerLabel.textContent = 'Alle Ergebnisse für „' + query + '“ anzeigen' + countSuffix; // textContent, keine Nutzerdaten in innerHTML (siehe Datei-Kopfkommentar)
    footer.appendChild(footerLabel);

    // Statischer Pfeil (keine Nutzerdaten) - wie im Original, damit der
    // Link auch optisch als "geht weiter" erkennbar ist (Michelle 15.07.).
    var arrowNs = 'http://www.w3.org/2000/svg';
    var arrow = document.createElementNS(arrowNs, 'svg');
    arrow.setAttribute('class', 'youro-search-viewall__arrow');
    arrow.setAttribute('viewBox', '0 0 24 24');
    var arrowPath = document.createElementNS(arrowNs, 'polyline');
    arrowPath.setAttribute('points', '9 6 15 12 9 18');
    arrow.appendChild(arrowPath);
    footer.appendChild(arrow);

    container.appendChild(footer);

    // Variante B (Michelle 15.07., zweiter Abgleich mit Mock-up): Kategorien
    // rutschen ans Ende der Kapsel, "Alle Ergebnisse anzeigen" eine Position hoch.
    var categoryEntries = topFacetEntries(data.facetDistribution, 'product_type', 3);
    if (categoryEntries.length) {
      var categoryRow = document.createElement('div');
      categoryRow.className = 'youro-search-category-row';

      var categoryLabel = document.createElement('span');
      categoryLabel.className = 'youro-search-category-row__label';
      categoryLabel.textContent = 'Passende Kategorien:';
      categoryRow.appendChild(categoryLabel);

      categoryEntries.forEach(function (entry) {
        categoryRow.appendChild(buildCategoryChip(entry, query, resultsPageUrl));
      });
      container.appendChild(categoryRow);
    }
  }

  // Ausverkaufte Treffer stabil ans Ende sortieren (nicht rausfiltern - falls
  // NICHTS verfuegbar ist, sollen trotzdem Treffer sichtbar bleiben, z.B. fuer
  // eine Warteliste) - Michelle 17.07.: "was bringt mir das, wenn mir
  // ausverkaufte Artikel angezeigt werden [ganz oben]".
  function sortAvailableFirst(hits) {
    var available = [];
    var unavailable = [];
    hits.forEach(function (hit) {
      (hit.available === false ? unavailable : available).push(hit);
    });
    return available.concat(unavailable);
  }

  // ── Modus 1: Autocomplete-Kapsel (Tippen) ────────────────────

  function attachAutocomplete(inputEl, resultsEl, options) {
    options = options || {};
    var limit = options.limit || 6;
    var debounceMs = options.debounceMs || 200;
    var resultsPageUrl = options.resultsPageUrl || '/pages/suche';
    var timer = null;
    var activeIndex = -1;

    function close() {
      resultsEl.innerHTML = '';
      resultsEl.classList.remove('youro-search-results--open');
      activeIndex = -1;
    }

    function onSelectSuggestion(suggestionText) {
      inputEl.value = suggestionText;
      inputEl.focus();
      // Youro (Fehler-Report Michelle 20.07.): runSearch() leert sofort
      // resultsEl.innerHTML, wodurch die gerade angeklickte Pille noch
      // WAEHREND der Klick-Event nach oben durchblubbert aus dem DOM entfernt
      // wird. Das native Theme-Skript (theme.js QuickSearch) hat einen
      // globalen window-Klick-Listener, der per event.target.closest(
      // '[data-quick-search]') prueft, ob ausserhalb der Suche geklickt
      // wurde - auf dem entfernten Knoten liefert closest() dann faelschlich
      // null, die Suche schliesst sich sofort wieder (Pille blitzt kurz auf,
      // verschwindet, Seite wirkt wie die Startseite). Fix: DOM-Leerung um
      // einen Tick verzoegern, damit der native Listener zuerst fertig wird.
      setTimeout(function () { runSearch(suggestionText); }, 0);
    }

    function runSearch(value) {
      if (!value) { close(); return; }
      // Sofort den Ladezustand zeigen, statt bis zu 1,5s lang wie "keine
      // Treffer" auszusehen (Michelle 20.07.) - wird unten durch die echten
      // Ergebnisse ersetzt, sobald die Antwort da ist.
      var thisSearchValue = value;
      resultsEl.innerHTML = '';
      resultsEl.appendChild(buildLoadingState());
      resultsEl.classList.add('youro-search-results--open');
      // Groesserer Rohabruf als angezeigt, damit verfuegbare Treffer nicht
      // von ausverkauften aus den sichtbaren Plaetzen verdraengt werden -
      // erst sortieren, dann auf die Anzeige-Anzahl kuerzen.
      // Patroa-Studio-Sichtbarkeit einschraenken (Entscheidung 014) - keine
      // Facetten-Filter in der Tipp-Vorschau, daher nur die Themen-Pruefung.
      var vendorClause = buildRestrictedVendorClause(value, null);
      search(value, limit * 2, ['product_type'], vendorClause).then(function (data) {
        // Waehrenddessen wurde weitergetippt - eine spaeter gestartete,
        // schnellere Anfrage hat evtl. schon das aktuellere Ergebnis
        // gezeigt; diese veraltete Antwort dann nicht mehr drueberrendern.
        if (inputEl.value.trim() !== thisSearchValue) { return; }
        data.hits = sortAvailableFirst(data.hits || []).slice(0, limit);
        renderAutocomplete(resultsEl, data, value, resultsPageUrl, onSelectSuggestion);
        resultsEl.classList.add('youro-search-results--open');
        activeIndex = -1;
      }).catch(function () {
        close();
      });
    }

    inputEl.addEventListener('input', function () {
      clearTimeout(timer);
      var value = inputEl.value.trim();
      timer = setTimeout(function () { runSearch(value); }, debounceMs);
    });

    // Tastatur-Navigation: Pfeiltasten, Escape
    inputEl.addEventListener('keydown', function (e) {
      var items = resultsEl.querySelectorAll('.youro-search-card');
      if (!items.length) { return; }

      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
        e.preventDefault();
        activeIndex = Math.min(activeIndex + 1, items.length - 1);
      } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
        e.preventDefault();
        activeIndex = Math.max(activeIndex - 1, 0);
      } else if (e.key === 'Escape') {
        close();
        return;
      } else if (e.key === 'Enter' && activeIndex >= 0) {
        e.preventDefault();
        items[activeIndex].click();
        return;
      } else {
        return;
      }

      items.forEach(function (el, i) {
        el.classList.toggle('youro-search-card--active', i === activeIndex);
        if (i === activeIndex) { el.scrollIntoView({ block: 'nearest', inline: 'nearest' }); }
      });
    });

    // Klick ausserhalb schliesst die Kapsel
    document.addEventListener('click', function (e) {
      if (!resultsEl.contains(e.target) && e.target !== inputEl) {
        close();
      }
    });

    return { close: close };
  }

  // ── Modus 2: Volle Ergebnisliste (nach Enter/Lupe) ───────────

  function attachSubmitRedirect(formOrInputEl, resultsPageUrl) {
    function redirect(value) {
      if (!value) { return; }
      window.location.href = resultsPageUrl + '?q=' + encodeURIComponent(value);
    }

    if (formOrInputEl.tagName === 'FORM') {
      formOrInputEl.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = formOrInputEl.querySelector('input[type="text"], input[type="search"]');
        redirect(input ? input.value.trim() : '');
      });
    } else {
      // einzelnes Input-Feld: Enter-Taste abfangen
      formOrInputEl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          redirect(formOrInputEl.value.trim());
        }
      });
    }
  }

  function renderResultsPage(containerEl, options) {
    options = options || {};
    var limit = options.limit || 48;
    var params = new URLSearchParams(window.location.search);
    var query = params.get('q') || '';

    var heading = document.createElement('div');
    heading.className = 'youro-search-heading';
    heading.textContent = query ? ('Ergebnisse für „' + query + '“') : 'Suche';
    containerEl.appendChild(heading);

    var resultsWrap = document.createElement('div');
    resultsWrap.className = 'youro-search-grid';
    containerEl.appendChild(resultsWrap);

    if (!query) { return; }

    search(query, limit).then(function (data) {
      var meta = document.createElement('div');
      meta.className = 'youro-search-meta';
      meta.textContent = (data.estimatedTotalHits || 0) + ' Treffer';
      containerEl.insertBefore(meta, resultsWrap);
      renderInto(resultsWrap, data.hits || []);
    }).catch(function () {
      resultsWrap.textContent = 'Suche momentan nicht verfügbar.';
    });
  }

  global.YouroSearch = {
    search: search,
    searchAdvanced: searchAdvanced,
    getSimilarProducts: getSimilarProducts,
    attachAutocomplete: attachAutocomplete,
    attachSubmitRedirect: attachSubmitRedirect,
    renderResultsPage: renderResultsPage,
    // Fuer youro-search-native.js (volle Ergebnisseite) - dieselbe Regel wie
    // in der Kapsel oben, zentral hier gepflegt (siehe Entscheidung 014).
    buildRestrictedVendorClause: buildRestrictedVendorClause
  };
})(window);
